import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import TrustForm from '../../../../components/TrustForm';

import {
    fetchCountries,
    fetchStates
} from '../../../../../../services/redux/commonData/actions';

import {
    editTrust,
    updateEditTrustPayload,
    handleEditTrustVisibility
} from '../../../../../../services/redux/employee/trust/actions';
import { formInputValidation } from '../../../../../../services/helper/form-helper';

class EditTrust extends Component {
    constructor(props) {
        super(props);
        this.trustFormRef = React.createRef();
    }

    componentDidMount() {
        let { fetchCountries, fetchStates } = this.props;
        fetchCountries();
        fetchStates();
    }

    onSaveClick = () => {
        let { trust, handleEditTrustVisibility, editTrust } = this.props;
        let payload = trust.editTrust;
        if (formInputValidation(this.trustFormRef.current)) {
            editTrust(payload).then(response => {
                if (response.status === 200) {
                    handleEditTrustVisibility(false);
                }
            });
        }
    };

    onBackClick = () => {
        let { handleEditTrustVisibility, location, history } = this.props;
        if (location.from && location.from !== '/client-details') {
            history.push({
                pathname: location.from,
                from: '/client-details'
            });
        } else {
            handleEditTrustVisibility(false);
        }
    };

    render() {
        let {
            trust,
            commonData,
            clientInformation,
            updateEditTrustPayload
        } = this.props;
        let saveButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onSaveClick}
            >
                Save
            </button>
        );

        let backButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );

        return (
            <div className="panel">
                <Tabs
                    defaultActiveKey={1}
                    id="tabID"
                    mountOnEnter={true}
                    unmountOnExit={true}
                >
                    <Tab eventKey={1} title="Edit Trust">
                        <Panel>
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <TrustForm
                                    trustData={trust.editTrust}
                                    clientList={clientInformation.clients}
                                    countryList={commonData.countries}
                                    stateList={commonData.states}
                                    updateTrustData={updateEditTrustPayload}
                                    formRef={this.trustFormRef}
                                />
                            </div>
                        </Panel>
                    </Tab>
                    <br />
                    {saveButton}
                    {backButton}
                </Tabs>
                {trust.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    trust: state.employee.trust,
    commonData: state.commonData,
    clientInformation: state.employee.clientInformation
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            editTrust,
            fetchCountries,
            fetchStates,
            updateEditTrustPayload,
            handleEditTrustVisibility
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditTrust));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/screens/EditTrust/index.js